// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementSqlQueriesQueryIdResult = objectOf({
  sql: string,
  results: arrayOf(arrayOf(anyOf(number, string))),
  status: string,
  error_message: string,
});
